// Colocated Driver.js tour for the Float Health dashboard, targeted at exec
// admins on their first visit. Walks the six cards in the order that maps to
// a real triage: read the runway clocks, act on the rebalance card if any,
// see anticipated spend from recent top-ups, see what is in flight with
// Safaricom, see any blocked payouts waiting for float, and read the 24 hour
// activity trend. Closes with the shared outro variant for wallet-less
// roles.

import { buildFaqOutroWithoutPinSteps } from '../../hooks/faqOutroSteps';

export const FLOAT_HEALTH_TOUR_ID = 'float-health-overview-v1';

export const buildFloatHealthTourSteps = ({ completedTourIds = [] } = {}) => [
    {
        title: 'Welcome, exec admin',
        description: 'This screen shows the health of your M-Pesa float in real time and tells you when to rebalance. We will walk it in a few short steps.',
    },
    {
        element: '[data-tour="float-health-runway"]',
        title: 'Runway clocks',
        description: 'Each clock estimates how long the account has before it runs dry, based on recent spending. Green means comfortable, amber means keep an eye on it, red means act now.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="float-health-rebalance"]',
        title: 'Rebalance suggestion',
        description: 'When one side is running short and the other has room, this card gives you the exact amount to move. Copy the amount, log in to the Safaricom Business Portal, complete the move, then log it in Fund Transfers.',
        side: 'bottom',
        align: 'center',
        skipMissingElement: true,
    },
    {
        element: '[data-tour="float-health-in-flight"]',
        title: 'In-flight escrow',
        description: 'Money already reserved for payouts we have sent to Safaricom but whose callbacks have not yet landed. A stuck row here often explains a puzzling drift on the reconciliation.',
        side: 'top',
        align: 'center',
    },
    {
        element: '[data-tour="float-health-runway"]',
        title: 'Sync with Daraja',
        description: 'Each account card has a small Sync with Daraja link under the Daraja balance row. Tap it to ask Daraja for a fresh number right now instead of waiting for the next scheduled sync. The balance and last synced time show a spinner while the sync runs, and the dashboard refreshes on its own after about fifteen seconds.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="float-health-reservations"]',
        title: 'Blocked payouts',
        description: 'When a user tries to pay but the float is too thin to cover it, we return the funds and log a row here. A spike is a real-time cry to rebalance. Empty is good.',
        side: 'top',
        align: 'center',
        skipMissingElement: true,
    },
    {
        element: '[data-tour="float-health-sparkline"]',
        title: '24 hour trend',
        description: 'A quick look at how each account has been draining hour by hour. Useful for spotting a busier-than-usual afternoon before it becomes a runway problem.',
        side: 'top',
        align: 'center',
    },
    ...buildFaqOutroWithoutPinSteps({ completedTourIds }),
];
